import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import { ReactComponent as ArrowTopSvg } from "images/top-arrow.svg";
import { ReactComponent as FileSvg } from "images/file.svg";
import { ReactComponent as ActionMenuIcon } from "images/ActionMenuIcon.svg";
import Button, { BUTTON_VARIANTS, BUTTON_COLORS } from "components/shared/Button/Button";
import { Modal } from "components-new";
import cn from "classnames";
import styles from "./Row.module.sass";
import DropSelect from "components-new/DropSelect";
import { Link, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { deleteDoc, downloadDoc, uploadDoc } from "toolkit/steps/stepFive/viewDocuments/viewDocuments.thunks";
import { setSelectedDocId } from "toolkit/steps/stepFive/viewDocuments/viewDocuments.slice";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";

interface RowProps {
	row: any;
	index: number;
	subRow?: boolean;
}

const File: React.FC<any> = ({ onClick, name, download, upload, id, kiiObjId, docsId }) => {
	const [active, setActive] = useState<any>({ show: false, ref: null });

	const { organizationId } = useParams();

	const refDrop = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		function handleClickOutside(event: any) {
			if (!refDrop.current?.contains(event.target)) {
				setActive({ show: false, ref: null });
			}
		}
		function handleClickOutsideContext(event: any) {
			if (active.ref && !active.ref?.contains(event.target)) {
				setActive({ show: false, ref: null });
			}
		}
		document.addEventListener("click", handleClickOutside);
		document.addEventListener("contextmenu", handleClickOutsideContext);
		return () => {
			document.removeEventListener("click", handleClickOutside);
			document.removeEventListener("contextmenu", handleClickOutsideContext);
		};
		//eslint-disable-next-line
	}, [active]);

	return (
		<>
			<span
				title={name}
				onClick={(e) => {
					e.stopPropagation();
					onClick();
				}}
				data-file={id + name}
				onContextMenu={(e) => {
					e.preventDefault();
					setActive(active.show ? { show: false, ref: null } : { show: true, ref: e.currentTarget });
				}}>
				<div className={styles.boxIcon}>
					<FileSvg className={styles.fileIcon} />
				</div>

				<span>
					<Link state={{ name, docsId }} to={`/categorization/documents/${organizationId}/${kiiObjId}/${id}`}>
						{name}
					</Link>
				</span>
				{active && <div className={styles.dropDown}></div>}
			</span>
			{active.show && (
				<DropSelect target={active.ref} position="left">
					<div ref={refDrop} className={styles.dropDown}>
						<label className={styles.option} onClick={() => {}}>
							<input
								type="file"
								accept=".docx, application/pdf"
								className={styles.inputFile}
								onChange={(e: any) => {
									let ext = e.target.value.match(/\.([^.]+)$/)[1];
									switch (ext) {
										case "docx":
											upload(e, id);
											break;
										case "pdf":
											upload(e, id);
											break;
									}
									setActive({ show: false, ref: null });
								}}
							/>
							Загрузить утвержденный документ
						</label>
						<div
							className={styles.option}
							onClick={() => {
								download(id, name);
							}}>
							Скачать
						</div>
					</div>
				</DropSelect>
			)}
		</>
	);
};

const Dots: React.FC<any> = ({ id, select }) => {
	const [active, setActive] = useState<any>({ show: false, ref: null });
	const onClick = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
		setActive(active.show ? { show: false, ref: null } : { show: true, ref: e.currentTarget });
	};
	useOutsideAlerter(active.ref, () => setActive({ show: false, ref: null }), 170);

	return (
		<>
			<ActionMenuIcon onClick={onClick} className={styles.actionsIcon} />
			{active.show && (
				<DropSelect target={active.ref} position="right">
					<div
						className={styles.dropDown}
						onClick={(e) => {
							e.stopPropagation();
						}}>
						{/* <div className={styles.option}>Версии</div> */}
						{id && (
							<div
								className={styles.option}
								onClick={() => {
									select(id);
									setActive({ show: false, ref: null });
								}}>
								Удалить документы по адресу
							</div>
						)}
					</div>
				</DropSelect>
			)}
		</>
	);
};

const Row: FC<RowProps> = ({ row, index, subRow = false }) => {
	const dispatch = useAppDispatch();

	const [isActive, setIsActive] = useState<boolean>(false);

	const [modalVisible, setModalVisible] = useState<boolean>(false);

	const selectedDocId = useAppSelector((state) => state.viewDocuments.selectedDocId);

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [dropDownDocx, setDropDownDocx] = useState<{
		show: boolean;
		ref: any;
	}>({ show: false, ref: null });

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [dropDownUploader, setDropDownUploader] = useState<{
		show: boolean;
		ref: any;
	}>({ show: false, ref: null });

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [drowDownActions, setDropDownActions] = useState<{
		show: boolean;
		ref: any;
	}>({ show: false, ref: null });

	useEffect(() => {
		const dropDownHide = () => {
			setDropDownDocx({ show: false, ref: null });
			setDropDownUploader({ show: false, ref: null });
		};

		document.addEventListener("click", dropDownHide);

		return () => {
			document.removeEventListener("click", dropDownHide);
		};
	}, []);

	const handleModal = (docId: number) => {
		setModalVisible(true);
		dispatch(setSelectedDocId(docId));
	};

	const onDelete = () => {
		dispatch(deleteDoc(selectedDocId));
		setModalVisible(false);
	};

	const onDownload = (docId: number, fileName: string) => {
		dispatch(downloadDoc({ docId, fileName }));
		setDropDownDocx({ show: false, ref: null });
		setDropDownUploader({ show: false, ref: null });
	};

	const { firstName, middleName, lastName } = useAppSelector((state) => state.profile.profile);

	const params = useParams();

	console.log(params);

	const onUpload = (e: any, docId: number) => {
		if (!e.target.files.length) {
			return;
		}
		const file = e.target.files[0];
		dispatch(
			uploadDoc({
				docId,
				file,
				userCred: { firstName, middleName, lastName },
				orgId: Number(params.organizationId),
			}),
		);
		setDropDownDocx({ show: false, ref: null });
		setDropDownUploader({ show: false, ref: null });
	};

	const checkSubRowsDocs = useMemo(() => {
		let res;

		if (row.subRows) {
			res = row.subRows.find((item: any) => {
				if (item.actDBid || item.resultDBid) {
					return true;
				}
				return false;
			});
		}

		return res;
	}, [row.subRows]);

	return (
		<React.Fragment>
			<div
				className={cn(styles.row, {
					[styles.active]: isActive,
					[styles.subRow]: subRow,
				})}
				onClick={() => !subRow && row.subRows && setIsActive((prevState) => !prevState)}>
				<div>
					{!subRow && row.subRows && checkSubRowsDocs && <ArrowTopSvg className={styles.arrowIcon} />}
					{index + 1}
				</div>

				<div>{row.addressId ? row.addressName : row.kiiObjName}</div>
				{/* <div>{row.kiiObjName}</div> */}
				<div className={styles.link}>
					{row.resultDocxName && (
						<File
							onClick={() => dispatch(setSelectedDocId(row.resultDBid))}
							name={row.resultDocxName}
							download={onDownload}
							upload={onUpload}
							id={row.resultDBid}
							kiiObjId={row.kiiObjId}
							docsId={{ actId: row.actDBid, resId: row.resultDBid }}
						/>
					)}

					{row.resultUploaderName && (
						<File
							onClick={() => dispatch(setSelectedDocId(row.actDBid))}
							name={row.actDocxName}
							download={onDownload}
							upload={onUpload}
							id={row.actDBid}
							kiiObjId={row.kiiObjId}
							docsId={{ actId: row.actDBid, resId: row.resultDBid }}
						/>
					)}
				</div>
				<div>
					<div className={styles.date}>{row.resultApprovalDate ? row.resultApprovalDate : "—"}</div>
					<div className={styles.date}>{row.actApprovalDate ? row.actApprovalDate : "—"}</div>
				</div>
				<div>
					<div className={styles.date}>{row.resultCreationDate ? row.resultCreationDate : "—"}</div>
					<div className={styles.date}>{row.actCreationDate ? row.actCreationDate : "—"}</div>
				</div>
				<div>
					<div style={{ height: 19 }}>{row.resultUploaderName === "System" ? "---" : row.resultUploaderName}</div>
					<div style={{ height: 19, marginTop: 20 }}>
						{row.actUploaderName === "System" ? "---" : row.actUploaderName}
					</div>
				</div>

				{subRow && (
					<Dots id={row.resultDBid || row.actDBid} select={handleModal} setDropDownActions={setDropDownActions} />
				)}
			</div>

			{isActive && (
				<>
					{row.subRows &&
						// eslint-disable-next-line array-callback-return
						row.subRows.map((subRow: any, index: number) => {
							if (subRow.actDBid || subRow.resultDBid) {
								return <Row row={subRow} key={index} index={index} subRow />;
							}
						})}
				</>
			)}

			{modalVisible && (
				<Modal handleClose={() => setModalVisible(false)}>
					<div className={styles.titleModal}>Удалить документы</div>
					<div className={styles.buttonsModal}>
						<Button
							className={styles.buttonModal}
							full
							variant={BUTTON_VARIANTS.OUTLINED}
							onClick={() => {
								setModalVisible(false);
							}}>
							Отмена
						</Button>
						<Button onClick={onDelete} className={styles.buttonModal} full color={BUTTON_COLORS.ERROR}>
							Удалить
						</Button>
					</div>
				</Modal>
			)}
		</React.Fragment>
	);
};

export default Row;
